module.exports = __webpack_public_path__ + "static/media/ribbons.96960da8.svg";